import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import SecurityPanel from './SecurityPanel';
import {BaseCard} from '../../../components/wizard';
import { extendedstyles } from '../../appstyles';

const s:any ={
  root: {
    width: '100%',
    display: 'flex',
    // overflow: 'scroll',
    justifyContent: 'space-between'
  },
  panel: {
    flex: '1 1 auto'
  },
};

class SecurityCard extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.props.deb.log("SecurityCard");
    this.state = {
      next: true,
      idtype: null,
      idfrom: null,
      fwopen: false
    };
  }

  render = () => {
    const { classes, theme, ...extraProps  } = this.props;
    const {record,data,extras,formdata,setItem} = this.props;
    return (
      <BaseCard
        cardid={'SECURITY'}
        cardname={'Security'}
        cardtitle={'Credentials'}
        instruction={'Provide security and authentication credentials for the agent'}
        step={2}
        buttons={['START','CANCEL','PREV','NEXT','GUIDE']}
        {...extraProps}
      >
        <SecurityPanel 
          data={extraProps.data}
          //record={record} 
          record={{...record,...formdata}}
          extras={extras}
          setItem={setItem}
          />
      </BaseCard>
    );
  }
}

SecurityCard.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default SecurityCard;
